(() => {
  function loadCevoid() {
    if (!window.cevoidScriptAdded) {
      const script = document.createElement('script');
      script.src = 'https://gallery.cevoid.com/index.js';
      script.type = 'module';
      script.defer = true;
      document.body.appendChild(script);

      window.cevoidScriptAdded = true;
    }

    if (typeof cevoid_gallery !== 'undefined') {
      cevoid_gallery.load();
    }
  }

  if (window.Shopify.designMode) {
    loadCevoid();
  }

  const container = document.querySelector('#cevoid-container');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          loadCevoid();
          observer.disconnect();
        }
      }
    },
    {
      rootMargin: '20% 0% 20% 0%',
      threshold: 0,
    },
  );

  if (container !== null) {
    observer.observe(container);
  }
})();
